"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2458],{

/***/ 78763:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$0": function() { return /* binding */ Section; },
/* harmony export */   "$C": function() { return /* binding */ ModuleTitle; },
/* harmony export */   "Dx": function() { return /* binding */ Title; },
/* harmony export */   "Pu": function() { return /* binding */ CenterOnSmallScreen; },
/* harmony export */   "VY": function() { return /* binding */ Content; },
/* harmony export */   "xv": function() { return /* binding */ Text; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19521);
/* harmony import */ var _colors__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22745);
/* harmony import */ var _mixins__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52873);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      padding: 3rem 0;\n\n      ",
        " {\n        font-size: 24px;\n        margin-bottom: 3rem;\n        text-align: center;\n\n        &::after {\n          left: 50%;\n          bottom: -10px;\n          margin-left: -1.5rem;\n        }\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  background: ",
        ";\n  padding: 4rem 0 6rem;\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n  width: 100%;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  font-size: 32px;\n  margin-bottom: 4rem;\n\n  && {\n    font-weight: normal;\n  }\n\n  &::after {\n    ",
        ";\n    content: '';\n    background: ",
        ";\n    position: absolute;\n    bottom: -6px;\n    left: 0;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n      justify-content: ",
        ";\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n  justify-content: space-between;\n  line-height: 1;\n  font-size: 20px;\n  font-weight: normal !important;\n  margin-bottom: 2rem;\n\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 16px;\n  color: ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n      ",
        "\n      text-align: center;\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}



var Section = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(_templateObject1(), _colors__WEBPACK_IMPORTED_MODULE_1__.F1, _colors__WEBPACK_IMPORTED_MODULE_1__.M1, function(props) {
    return props.isSmallScreen && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(_templateObject(), Title);
});
var Content = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(_templateObject2(), _mixins__WEBPACK_IMPORTED_MODULE_2__/* .responsive */ .jW());
var Title = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].h2 */ .ZP.h2(_templateObject3(), _mixins__WEBPACK_IMPORTED_MODULE_2__/* .size */ .dp("3rem", "10px"), _colors__WEBPACK_IMPORTED_MODULE_1__.B1);
var ModuleTitle = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].h3 */ .ZP.h3(_templateObject5(), _mixins__WEBPACK_IMPORTED_MODULE_2__/* .flexVerticalCenter */ .VL(), function(props) {
    return props.justify && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(_templateObject4(), props.justify);
});
var Text = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(_templateObject6(), _colors__WEBPACK_IMPORTED_MODULE_1__.F2);
var CenterOnSmallScreen = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(_templateObject8(), function(props) {
    return props.isSmallScreen && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(_templateObject7(), _mixins__WEBPACK_IMPORTED_MODULE_2__/* .centerBlock */ .EM());
});


/***/ }),

/***/ 580:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Anchor; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


function Anchor(_param) {
    var target = _param.target, rel = _param.rel, isHash = _param.isHash, rest = _objectWithoutProperties(_param, [
        "target",
        "rel",
        "isHash"
    ]);
    var props = _objectSpread({}, rest);
    //const isInternalLink = rest.href.charAt(0) === '/'
    //const hasHash = props.href.includes('#') && isInternalLink
    props.target = isHash ? "" : target !== null && target !== void 0 ? target : "_blank";
    props.rel = isHash ? "" : rel !== null && rel !== void 0 ? rel : "noopener noreferrer";
    var _children;
    var children = (_children = props.children) !== null && _children !== void 0 ? _children : props.href;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", _objectSpread({}, props, {
        children: children
    }));
};


/***/ }),

/***/ 48556:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ EmptyStatus; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./packages/ui/src/mixins.ts
var mixins = __webpack_require__(52873);
// EXTERNAL MODULE: ./packages/ui/src/colors.ts
var colors = __webpack_require__(22745);
;// CONCATENATED MODULE: ./src/components/EmptyStatus/index.styled.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n  background-color: #fff;\n  border-radius: 4px;\n  padding: 10rem 1rem;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  a {\n    color: ",
        ";\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Container = styled_components_browser_esm/* default.div */.ZP.div(_templateObject(), mixins/* boxShadow */.Wn(), colors.B1); //export const Image = styled.div`
 //  margin: 2rem;
 //`;
 //
 //export const Title = styled.div`
 //  font-weight: bolder;
 //`;
 //
 //export const Body = styled.div`
 //  a {
 //    color: ${colors.B1};
 //    &:hover {
 //      text-decoration: underline;
 //    }
 //  }
 //`;

// EXTERNAL MODULE: ./node_modules/antd/es/empty/index.js + 2 modules
var empty = __webpack_require__(62986);
// EXTERNAL MODULE: ./src/utils/index.js + 3 modules
var utils = __webpack_require__(59874);
;// CONCATENATED MODULE: ./src/components/EmptyStatus/index.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}





function EmptyStatus(_param) {
    var description = _param.description, children = _param.children, rest = _objectWithoutProperties(_param, [
        "description",
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, _objectSpread({}, rest, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(empty/* default */.Z, {
            description: description,
            image: utils/* cdn.getImageUrl */.cK.getImageUrl("/images/profile/undraw_ride_a_bicycle_re_6tjy.svg"),
            children: children
        })
    }));
};


/***/ }),

/***/ 25458:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20550);



var BlogStatusBadge = function(param) {
    var status = param.status;
    var color = "";
    var text = "";
    switch(status){
        case "PUBLISHED":
            {
                color = "#F8C200";
                text = "\u5DF2\u53D1\u5E03";
                break;
            }
        case "DRAFT":
            {
                color = "#D8D8D8";
                text = "\u8349\u7A3F";
                break;
            }
        case "PENDING":
            {
                color = "#7D3F98";
                text = "\u5BA1\u6838\u4E2D";
                break;
            }
        case "REJECTED":
            {
                color = "#FF6D78";
                text = "\u5BA1\u6838\u672A\u901A\u8FC7";
                break;
            }
        default:
            {
                color = "#FFF";
            }
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        color: color,
        children: text
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BlogStatusBadge);


/***/ }),

/***/ 53662:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ListItem_ListItem; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./packages/ui/src/mixins.ts
var mixins = __webpack_require__(52873);
// EXTERNAL MODULE: ./packages/ui/src/colors.ts
var colors = __webpack_require__(22745);
// EXTERNAL MODULE: ./src/components/Anchor.tsx
var Anchor = __webpack_require__(580);
;// CONCATENATED MODULE: ./src/pages/u/[username]/_components/ListItem/index.styled.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: 0.75rem;\n  ",
        ";\n  background-color: #fff;\n  border-radius: 4px;\n  padding: 2rem;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  margin-left: 0.5rem;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: 0.5rem;\n  margin-bottom: 1rem;\n  word-wrap: break-word;\n  .emoji {\n    height: 1.5rem;\n  }\n  a {\n    color: ",
        ";\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}



var ListItem = styled_components_browser_esm/* default.div */.ZP.div(_templateObject(), mixins/* boxShadow */.Wn());
var Title = styled_components_browser_esm/* default.div */.ZP.div(_templateObject1());
var TitleText = (0,styled_components_browser_esm/* default */.ZP)(Anchor/* default */.Z)(_templateObject2(), mixins/* typography */.cp("h2"));
var TitleBadge = styled_components_browser_esm/* default.div */.ZP.div(_templateObject3());
var Summary = styled_components_browser_esm/* default.div */.ZP.div(_templateObject4(), colors.B1);
var Metadata = styled_components_browser_esm/* default.div */.ZP.div(_templateObject5());
var MetadataStart = styled_components_browser_esm/* default.div */.ZP.div(_templateObject6());
var MetadataEnd = styled_components_browser_esm/* default.div */.ZP.div(_templateObject7());

// EXTERNAL MODULE: ./src/pages/blog/_components/BlogStatusBadge/BlogStatusBadge.tsx
var BlogStatusBadge = __webpack_require__(25458);
;// CONCATENATED MODULE: ./src/pages/u/[username]/_components/ListItem/index.tsx




function ListItem_ListItem(props) {
    var url = props.url, title = props.title, summary = props.summary, metadataStart = props.metadataStart, metadataEnd = props.metadataEnd, status = props.status;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItem, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Title, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleText, {
                        href: url,
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleBadge, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogStatusBadge/* default */.Z, {
                            status: status
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Summary, {
                dangerouslySetInnerHTML: {
                    __html: summary
                }
            }),
            (metadataStart || metadataEnd) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Metadata, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MetadataStart, {
                        children: metadataStart
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MetadataEnd, {
                        children: metadataEnd
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 78468:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ProfileLayout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/antd/es/space/index.js + 1 modules
var space = __webpack_require__(26713);
// EXTERNAL MODULE: ./src/components/index.js + 20 modules
var components = __webpack_require__(21679);
// EXTERNAL MODULE: ./src/layouts/index.js + 13 modules
var layouts = __webpack_require__(59269);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./packages/ui/src/styled.ts
var styled = __webpack_require__(78763);
// EXTERNAL MODULE: ./packages/ui/src/constants.ts
var constants = __webpack_require__(52483);
;// CONCATENATED MODULE: ./src/pages/u/[username]/_components/ProfileLayout/index.styled.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  padding: 2rem 1rem;\n  @media screen and (max-width: ",
        ") {\n    flex-direction: column;\n    padding: 1rem 0.5rem;\n    & > div {\n      width: 100%;\n    }\n  }\n  //@media screen and (min-width: (",
        " + 1)) {\n  //  padding: 2rem 1rem;\n  //}\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  width: 340px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  width: calc(100% - 350px);\n  margin-left: 2rem;\n  @media screen and (max-width: ",
        ") {\n    margin-top: 2rem;\n    margin-left: 0;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

//import {  } from 'antd';

var Content = styled/* Content */.VY;

var Container = styled_components_browser_esm/* default.div */.ZP.div(_templateObject(), constants/* breakPoints.md */.Eg.md, constants/* breakPoints.md */.Eg.md);
var Start = styled_components_browser_esm/* default.div */.ZP.div(_templateObject1());
var End = styled_components_browser_esm/* default.div */.ZP.div(_templateObject2(), constants/* breakPoints.md */.Eg.md);

// EXTERNAL MODULE: ./packages/ui/src/mixins.ts
var mixins = __webpack_require__(52873);
// EXTERNAL MODULE: ./packages/ui/src/colors.ts
var colors = __webpack_require__(22745);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 3 modules
var polished_esm = __webpack_require__(43281);
// EXTERNAL MODULE: ./src/components/Anchor.tsx
var Anchor = __webpack_require__(580);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/IdcardOutlined.js + 1 modules
var IdcardOutlined = __webpack_require__(75642);
;// CONCATENATED MODULE: ./src/pages/u/[username]/_components/ProfileCard/index.styled.ts
function index_styled_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function index_styled_templateObject() {
    var data = index_styled_taggedTemplateLiteral([
        "\n  ",
        ";\n  background-color: #fff;\n  border-radius: 4px;\n  border-top: 4px solid ",
        ";\n  padding: 0.5rem 1rem;\n"
    ]);
    index_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function index_styled_templateObject1() {
    var data = index_styled_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n"
    ]);
    index_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function index_styled_templateObject2() {
    var data = index_styled_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 0 1rem;\n"
    ]);
    index_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = index_styled_taggedTemplateLiteral([
        ""
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = index_styled_taggedTemplateLiteral([
        ""
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = index_styled_taggedTemplateLiteral([
        "\n  ",
        ";\n  box-shadow: 0 2px 6px 0 ",
        ";\n  img {\n    width: 100%;\n    height: 100%;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = index_styled_taggedTemplateLiteral([
        "\n  display: flex;\n  margin-top: 1.5rem;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = index_styled_taggedTemplateLiteral([
        "\n  ",
        ";\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = index_styled_taggedTemplateLiteral([
        "\n  ",
        ";\n  margin-left: 0.5rem;\n  color: ",
        ";\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = index_styled_taggedTemplateLiteral([
        "\n  ",
        ";\n  margin-top: 1.5rem;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = index_styled_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 1.5rem;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = index_styled_taggedTemplateLiteral([
        "\n  font-size: 1.5rem;\n  color: ",
        ";\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = index_styled_taggedTemplateLiteral([
        "\n  ",
        ";\n  margin-left: 0.5rem;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = index_styled_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n  margin-top: 2rem;\n  margin-bottom: 1.5rem;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = index_styled_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  &:not(:last-child) {\n    border-right: 2px solid ",
        ";\n  }\n  margin: 1rem 0;\n  padding: 0 1.5rem;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = index_styled_taggedTemplateLiteral([
        "\n  ",
        ";\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = index_styled_taggedTemplateLiteral([
        "\n  ",
        ";\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}





var index_styled_Container = styled_components_browser_esm/* default.div.attrs */.ZP.div.attrs({})(index_styled_templateObject(), mixins/* boxShadow */.Wn(), colors.B1);
var Action = styled_components_browser_esm/* default.div */.ZP.div(index_styled_templateObject1());
var Main = styled_components_browser_esm/* default.div */.ZP.div(index_styled_templateObject2());
var Edit = styled_components_browser_esm/* default.a */.ZP.a(_templateObject3());
var Chat = (0,styled_components_browser_esm/* default */.ZP)(Anchor/* default */.Z)(_templateObject4());
var AvatarSize = "5rem";
var Avatar = styled_components_browser_esm/* default.div */.ZP.div(_templateObject5(), mixins/* radius */.q0(AvatarSize), polished_esm/* rgba */.m4("#000", 0.5));
var Name = styled_components_browser_esm/* default.div */.ZP.div(_templateObject6());
var NameText = styled_components_browser_esm/* default.div */.ZP.div(_templateObject7(), mixins/* typography */.cp("h3"));
var Level = styled_components_browser_esm/* default.div */.ZP.div(_templateObject8(), mixins/* typography */.cp("h3"), colors.B1);
var Description = styled_components_browser_esm/* default.div */.ZP.div(_templateObject9(), mixins/* typography */.cp("p2"));
var JoinDate = styled_components_browser_esm/* default.div */.ZP.div(_templateObject10());
var JoinDateIcon = (0,styled_components_browser_esm/* default */.ZP)(IdcardOutlined/* default */.Z)(_templateObject11(), colors.F2);
var JoinDateText = styled_components_browser_esm/* default.div */.ZP.div(_templateObject12(), mixins/* typography */.cp("p2"));
var Nums = styled_components_browser_esm/* default.div */.ZP.div(_templateObject13());
var NumsItem = styled_components_browser_esm/* default.div */.ZP.div(_templateObject14(), colors.C2);
var NumsItemKeyName = styled_components_browser_esm/* default.div */.ZP.div(_templateObject15(), mixins/* typography */.cp("p2"));
var NumsItemValue = styled_components_browser_esm/* default.div */.ZP.div(_templateObject16(), mixins/* typography */.cp("h1"));

// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/EditFilled.js + 1 modules
var EditFilled = __webpack_require__(36531);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/MailFilled.js + 1 modules
var MailFilled = __webpack_require__(48245);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/api/asktug/profile.ts
var profile = __webpack_require__(21049);
// EXTERNAL MODULE: ./src/pages/u/[username]/profile.hook.ts
var profile_hook = __webpack_require__(95389);
;// CONCATENATED MODULE: ./src/pages/u/[username]/_components/ProfileCard/index.tsx



// import Image from 'next/image';




function ProfileCard(props) {
    var avatarUrl = props.avatarUrl, name = props.name, level = props.level, description = props.description, joinDate = props.joinDate, nums = props.nums;
    var isCurrentLogonUser = (0,profile_hook/* useCurrentLogonUser */.Y)(name);
    var _like, _answer, _post;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_styled_Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Action, {
                children: [
                    isCurrentLogonUser ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "https://tidb.net/my/profile",
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Edit, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EditFilled/* default */.Z, {})
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Chat, {
                        href: "".concat(profile.askTugDomain, "/new-message?username=").concat(props.name),
                        children: [
                            "\u79C1\u4FE1 ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MailFilled/* default */.Z, {})
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Main, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: avatarUrl,
                            alt: name
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Name, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NameText, {
                                children: name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Level, {
                                children: [
                                    "V",
                                    level
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Description, {
                        children: description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(JoinDate, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(JoinDateIcon, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(JoinDateText, {
                                children: [
                                    "\u4E8E ",
                                    joinDate,
                                    " \u52A0\u5165"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Nums, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(NumsItem, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NumsItemKeyName, {
                                        children: "\u83B7\u8D5E"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NumsItemValue, {
                                        children: (_like = nums.like) !== null && _like !== void 0 ? _like : "-"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(NumsItem, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NumsItemKeyName, {
                                        children: "\u56DE\u7B54"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NumsItemValue, {
                                        children: (_answer = nums.answer) !== null && _answer !== void 0 ? _answer : "-"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(NumsItem, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NumsItemKeyName, {
                                        children: "\u6587\u7AE0"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NumsItemValue, {
                                        children: (_post = nums.post) !== null && _post !== void 0 ? _post : "-"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/pages/u/[username]/_components/BadgeCard/index.styled.ts
function BadgeCard_index_styled_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function BadgeCard_index_styled_templateObject() {
    var data = BadgeCard_index_styled_taggedTemplateLiteral([
        "\n  ",
        ";\n  background-color: #fff;\n  border-radius: 4px;\n  padding: 32px 16px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n"
    ]);
    BadgeCard_index_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function BadgeCard_index_styled_templateObject1() {
    var data = BadgeCard_index_styled_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  width: 100%;\n"
    ]);
    BadgeCard_index_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function BadgeCard_index_styled_templateObject2() {
    var data = BadgeCard_index_styled_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: flex-end;\n"
    ]);
    BadgeCard_index_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function index_styled_templateObject3() {
    var data = BadgeCard_index_styled_taggedTemplateLiteral([
        "\n  ",
        ";\n  color: ",
        ";\n"
    ]);
    index_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function index_styled_templateObject4() {
    var data = BadgeCard_index_styled_taggedTemplateLiteral([
        "\n  ",
        ";\n  margin-left: 0.5rem;\n"
    ]);
    index_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function index_styled_templateObject5() {
    var data = BadgeCard_index_styled_taggedTemplateLiteral([
        "\n  color: ",
        ";\n"
    ]);
    index_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function index_styled_templateObject6() {
    var data = BadgeCard_index_styled_taggedTemplateLiteral([
        "\n  margin-top: 32px;\n"
    ]);
    index_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function index_styled_templateObject7() {
    var data = BadgeCard_index_styled_taggedTemplateLiteral([
        "\n  opacity: ",
        ";\n  //margin: 4px;\n  width: 52px;\n  height: 52px;\n  //height: 2.5rem;\n  img {\n    width: 100%;\n    height: 100%;\n  }\n"
    ]);
    index_styled_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}




var BadgeCard_index_styled_Container = styled_components_browser_esm/* default.div.attrs */.ZP.div.attrs({})(BadgeCard_index_styled_templateObject(), mixins/* boxShadow */.Wn());
var Header = styled_components_browser_esm/* default.div */.ZP.div(BadgeCard_index_styled_templateObject1());
var Title = styled_components_browser_esm/* default.div */.ZP.div(BadgeCard_index_styled_templateObject2());
var TitleText = styled_components_browser_esm/* default.div */.ZP.div(index_styled_templateObject3(), mixins/* typography */.cp("h3"), colors.F2);
var TitleNums = styled_components_browser_esm/* default.div */.ZP.div(index_styled_templateObject4(), mixins/* typography */.cp("p2"));
var ActiveMore = (0,styled_components_browser_esm/* default */.ZP)(Anchor/* default */.Z)(index_styled_templateObject5(), colors.B1);
//export const Body = styled.div`
//  display: flex;
//  justify-content: center;
//  flex-wrap: wrap;
//  margin-top: 32px;
//  //gap: .5rem;
//  //width: 100%;
//`;
var Body = (0,styled_components_browser_esm/* default */.ZP)(space/* default */.Z).attrs({
    gutter: [
        4,
        8
    ],
    wrap: true
})(index_styled_templateObject6());
var Badge = styled_components_browser_esm/* default.div */.ZP.div(index_styled_templateObject7(), function(props) {
    return props.hasBadge ? "100%" : "30%";
});

// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/BulbFilled.js + 1 modules
var BulbFilled = __webpack_require__(24966);
// EXTERNAL MODULE: ./node_modules/antd/es/tooltip/index.js + 5 modules
var tooltip = __webpack_require__(36084);
;// CONCATENATED MODULE: ./src/pages/u/[username]/_components/BadgeCard/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}






var _NEXT_PUBLIC_ASKTUG_WEBSITE_BASE_URL;
var NEXT_PUBLIC_ASKTUG_WEBSITE_BASE_URL = (_NEXT_PUBLIC_ASKTUG_WEBSITE_BASE_URL = "https://new.asktug.com") !== null && _NEXT_PUBLIC_ASKTUG_WEBSITE_BASE_URL !== void 0 ? _NEXT_PUBLIC_ASKTUG_WEBSITE_BASE_URL : "https://asktug.com";
function BadgeCard_ProfileCard(props) {
    var badges = props.badges;
    var hasBadges = badges.filter(function(value) {
        return value.has_badge === true;
    });
    var hasNotBadges = badges.filter(function(value) {
        return value.has_badge === false;
    });
    var nums = {
        total: badges.length,
        current: hasBadges.length
    };
    var mergedBadges = _toConsumableArray(hasBadges).concat(_toConsumableArray(hasNotBadges)).slice(0, 10);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BadgeCard_index_styled_Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Header, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Title, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleText, {
                                children: "\u5FBD\u7AE0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TitleNums, {
                                children: [
                                    nums.current,
                                    "/",
                                    nums.total
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ActiveMore, {
                        href: "".concat(NEXT_PUBLIC_ASKTUG_WEBSITE_BASE_URL, "/badges"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BulbFilled/* default */.Z, {
                                style: {
                                    color: colors.T5
                                }
                            }),
                            " \u70B9\u4EAE\u66F4\u591A\u5FBD\u7AE0"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Body, {
                children: mergedBadges.map(function(value) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge, {
                        hasBadge: value.has_badge,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip/* default */.Z, {
                            placement: "topLeft",
                            title: "".concat(value.name).concat(value.description ? " - " + value.description : "", " ").concat(value.long_description ? "(".concat(value.long_description, ")") : ""),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "".concat(NEXT_PUBLIC_ASKTUG_WEBSITE_BASE_URL, "/").concat(value.image_url),
                                alt: value.name
                            })
                        })
                    }, value.id);
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/pages/u/[username]/_components/ProfileLayout/index.tsx








function ProfileLayout(param) {
    var children = param.children, badges = param.badges, profile = param.profile, nums = param.nums;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CommunityHead */.Wh, {
                title: "\u4E2A\u4EBA\u8D44\u6599 - ".concat(profile.username)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(layouts/* CoreLayout */.N, {
                backgroundColor: "#e9eaee",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Start, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(space/* default */.Z, {
                                    direction: "vertical",
                                    size: 32,
                                    style: {
                                        width: "100%"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileCard, {
                                            avatarUrl: profile.avatar_url,
                                            name: profile.username,
                                            level: profile.level,
                                            description: profile.bio,
                                            joinDate: profile.joined_at,
                                            nums: nums
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BadgeCard_ProfileCard, {
                                            badges: badges
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(End, {
                                children: children
                            })
                        ]
                    })
                })
            })
        ]
    });
};


/***/ }),

/***/ 90568:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$": function() { return /* binding */ EUgcType; },
  "Z": function() { return /* binding */ Tab_Tab; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./packages/ui/src/colors.ts
var colors = __webpack_require__(22745);
;// CONCATENATED MODULE: ./src/pages/u/[username]/_components/Tab/index.styled.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  overflow: auto;\n  width: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: flex-end;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: flex-end;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  border-bottom: 4px solid ",
        ";\n  color: ",
        ";\n  display: block;\n  padding: 0.25rem 0;\n  margin-right: 1.5rem;\n  white-space: nowrap;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var Tab = styled_components_browser_esm/* default.div */.ZP.div(_templateObject());
var Start = styled_components_browser_esm/* default.div */.ZP.div(_templateObject1());
var End = styled_components_browser_esm/* default.div */.ZP.div(_templateObject2());
var TabItem = styled_components_browser_esm/* default.a */.ZP.a(_templateObject3(), function(props) {
    return props.selected ? colors.B1 : "rgba(0,0,0,0)";
}, function(props) {
    return props.selected ? colors.B1 : "black";
});

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/pages/u/[username]/profile.hook.ts
var profile_hook = __webpack_require__(95389);
;// CONCATENATED MODULE: ./src/pages/u/[username]/_components/Tab/index.tsx






var EUgcType;
(function(EUgcType) {
    EUgcType[EUgcType["answer"] = 0] = "answer";
    EUgcType[EUgcType["question"] = 1] = "question";
    EUgcType[EUgcType["post"] = 2] = "post";
    EUgcType[EUgcType["favorite"] = 3] = "favorite";
})(EUgcType || (EUgcType = {}));
function Tab_Tab(props) {
    var selected = props.selected, nums = props.nums, extendDom = props.extendDom;
    var router = (0,next_router.useRouter)();
    var username = router.query.username;
    var prefix = "/u/".concat(encodeURIComponent(username));
    var isCurrentLogonUser = (0,profile_hook/* useCurrentLogonUser */.Y)(username);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tab, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Start, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "".concat(prefix, "/answer"),
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabItem, {
                            selected: selected === EUgcType.answer,
                            children: [
                                "\u56DE\u7B54 ",
                                nums.answer
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "".concat(prefix, "/question"),
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabItem, {
                            selected: selected === EUgcType.question,
                            children: [
                                "\u63D0\u95EE ",
                                nums.question
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "".concat(prefix, "/post/all"),
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabItem, {
                            selected: selected === EUgcType.post,
                            children: [
                                "\u6587\u7AE0 ",
                                nums.post
                            ]
                        })
                    }),
                    isCurrentLogonUser && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "".concat(prefix, "/favorite"),
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabItem, {
                            selected: selected === EUgcType.favorite,
                            children: [
                                "\u6536\u85CF ",
                                nums.favorite
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(End, {
                children: extendDom
            })
        ]
    });
};


/***/ }),

/***/ 82012:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "KN": function() { return /* binding */ filterSelectWidth; },
/* harmony export */   "aU": function() { return /* binding */ Action; },
/* harmony export */   "aV": function() { return /* binding */ List; }
/* harmony export */ });
/* unused harmony exports Tab, Pagination */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19521);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  margin: 1rem 0;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  margin: 1.5rem auto;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding-bottom: 1.5rem;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}

var filterSelectWidth = "10rem";
var Action = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(_templateObject());
var Tab = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(_templateObject1());
var List = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(_templateObject2());
var Pagination = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(_templateObject3());


/***/ }),

/***/ 48956:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ blogUrl; },
/* harmony export */   "s": function() { return /* binding */ forumUrl; }
/* harmony export */ });
var forumUrl = "https://asktug.com";
var blogUrl = "https://tidb.net/blog";


/***/ }),

/***/ 95389:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ useCurrentLogonUser; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _context_me_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54887);


function useCurrentLogonUser(username) {
    var ref;
    var me = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_context_me_context__WEBPACK_IMPORTED_MODULE_1__/* .MeContext */ .i);
    var currentUsername = me === null || me === void 0 ? void 0 : (ref = me.meData) === null || ref === void 0 ? void 0 : ref.username;
    if (currentUsername === undefined) {
        return null;
    } else {
        return username === currentUsername;
    }
}


/***/ }),

/***/ 11093:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ getRelativeDatetime; }
/* harmony export */ });
/* unused harmony export sleep */
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var dayjs_plugin_relativeTime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84110);
/* harmony import */ var dayjs_plugin_relativeTime__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_relativeTime__WEBPACK_IMPORTED_MODULE_1__);


dayjs__WEBPACK_IMPORTED_MODULE_0___default().extend((dayjs_plugin_relativeTime__WEBPACK_IMPORTED_MODULE_1___default()));
function getRelativeDatetime(datetime) {
    return dayjs__WEBPACK_IMPORTED_MODULE_0___default()().to(dayjs__WEBPACK_IMPORTED_MODULE_0___default()(datetime));
}
function sleep(milliseconds) {
    return new Promise(function(resolve) {
        return setTimeout(resolve, milliseconds);
    });
}


/***/ })

}]);